<template>
  <div class="page">
    <div class="page_contents">
      <div class="page_header">회원가입({{props.회원구분 == '통합' ? '통합' : '일반'}}회원)</div>
      <div class="page_header_line"></div>
      <div class="steps">
        <div class="step active">
          <div class="step_circle">
            <img src="@/assets/images/step_check.png" />
            <div class="step_label">약관동의</div>
          </div>
        </div>
        <div class="step active">
          <div class="step_line"></div>
          <div class="step_circle">
            <div class="step_label">정보입력</div>
          </div>
        </div>
        <div class="step">
          <div class="step_line"></div>
          <div class="step_circle">
            <div class="step_label">인증서등록</div>
          </div>
        </div>
        <div class="step">
          <div class="step_line"></div>
          <div class="step_circle">
            <div class="step_label">심사 후 승인</div>
          </div>
        </div>
      </div>
    </div>
    <div class="join_header">정보입력</div>
    <div>
      <div id="input-wrapper">
        <div class="form-group">
          <label for="companyName">사업자명</label>
          <div class="company-input">
            <input type="text" id="companyName" v-model="form.companyName" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="businessType">사업자구분</label>
          <div class="businesstype-inputs">
            <label>
              <input type="radio" value="개인" v-model="form.businessType" />
              개인
            </label>
            <label>
              <input type="radio" value="법인" v-model="form.businessType" />
              법인
            </label>
          </div>
        </div>
        <div class="form-group">
          <label for="businessNumber">사업자번호</label>
          <div class="business-inputs">
            <input 
              type="text" 
              id="businessNumber1" 
              v-model="form.businessNumber1" 
              @input="handleBusinessNumber('businessNumber1', 'businessNumber2', 3)"
              maxlength="3"
              ref="businessNumber1Input"
              autocomplete='off'
            />
            <input 
              type="text" 
              id="businessNumber2" 
              v-model="form.businessNumber2" 
              @input="handleBusinessNumber('businessNumber2', 'businessNumber3', 2)"
              maxlength="2"
              ref="businessNumber2Input"
              autocomplete='off'
            />
            <input 
              type="text" 
              id="businessNumber3" 
              v-model="form.businessNumber3" 
              @input="handleBusinessNumber('businessNumber3', '', 5)"
              maxlength="5"
              ref="businessNumber3Input"
              autocomplete='off'
            />
          </div>
        </div>
        <div class="form-group">
          <label for="managerName">대표자명</label>
          <div class="company-input">
            <input type="text" id="managerName" v-model="form.representativeName" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="phoneNumber">대표자 전화번호</label>
          <div class="phone-inputs">
            <input type="text" id="phoneNumber1" v-model="form.phoneNumber1" autocomplete='off'/>
            <input type="text" id="phoneNumber2" v-model="form.phoneNumber2" autocomplete='off'/>
            <input type="text" id="phoneNumber3" v-model="form.phoneNumber3" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="managerName">담당자명</label>
          <div class="company-input">
            <input type="text" id="managerName" v-model="form.managerName" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="managerPhone">담당자 전화번호</label>
          <div class="business-inputs">
            <input type="text" id="managerPhone1" v-model="form.managerPhone1" autocomplete='off'/>
            <input type="text" id="managerPhone2" v-model="form.managerPhone2" autocomplete='off'/>
            <input type="text" id="managerPhone3" v-model="form.managerPhone3" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="taxEmail">담당자 이메일</label>
          <div class="email-inputs">
            <input class="email1" type="text" v-model="form.email1" autocomplete='off'/>
            <div class="dot">@</div>
            <input class="email2" type="text" v-model="form.email2" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="companyAddress">주소</label>
          <div class="address-inputs">
            <input class="address1" readonly type="search" id="companyAddress1" v-model="form.companyAddress1" @click="searchAddr(1)" />
            <input class="address2" readonly type="text" id="companyAddress2" v-model="form.companyAddress2" @click="searchAddr(1)" />
          </div>
        </div>
        <div class="form-group">
          <label for="addressDetail">상세주소</label>
          <div class="company-input">
            <input type="text" id="addressDetail" v-model="form.addressDetail" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="companyAddress">주소2</label>
          <div class="address-inputs">
            <input class="address1" readonly type="search" id="companyAddress1" v-model="form.companyAddress21" @click="searchAddr(2)" />
            <input class="address2" readonly type="text" id="companyAddress2" v-model="form.companyAddress22" @click="searchAddr(2)"/>
          </div>
        </div>
        <div class="form-group">
          <label for="addressDetail">상세주소2</label>
          <div class="company-input">
            <input type="text" id="addressDetail" v-model="form.addressDetail2" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="remarks">비고</label>
          <div class="company-input">
            <input type="text" id="remarks" v-model="form.remarks" autocomplete='off'/>
          </div>
        </div>
        <div class="form-group">
          <label for="file">사업자등록증</label>
          <div class="filebox">
            <div v-if="uploadedFileName" class="file-name">
              {{ uploadedFileName }}
            </div>
            <label for="file">파일 첨부 +</label>
            <input type="file" id="file" @change="handleFileUpload" />
          </div>
        </div>
      </div>
      <div class="submit-btn">
        <button type="submit" class="submit-button" @click="signUp">다음</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Member } from "@/common/types";
import { ref, defineProps, defineEmits, onMounted } from "vue";

const props = defineProps<{
  member: Member;
  회원구분: string | null;
}>();
const emit = defineEmits(["setUser"]);
const form = ref({
  companyName: "",
  businessType: "개인",
  businessNumber1: "",
  businessNumber2: "",
  businessNumber3: "",
  representativeName: "",
  managerName: "",
  phoneNumber1: "",
  phoneNumber2: "",
  phoneNumber3: "",
  managerPhone1: "",
  managerPhone2: "",
  managerPhone3: "",
  email1: "",
  email2: "",
  companyAddress1: "",
  companyAddress2: "",
  addressDetail: "",
  companyAddress21: "",
  companyAddress22: "",
  addressDetail2: "",
  remarks: "",
  file: null as File | null, // 파일 초기화
});
onMounted(() => {
  form.value = {
    companyName: props.member.사업자명,
    businessType: props.member.사업자구분,
    businessNumber1: props.member.사업자번호.slice(0, 3),
    businessNumber2: props.member.사업자번호.slice(3, 5),
    businessNumber3: props.member.사업자번호.slice(5, 10),
    representativeName: props.member.대표자명,
    managerName: props.member.담당자명,
    phoneNumber1: props.member.대표자전화번호.slice(0, 3),
    phoneNumber2: props.member.대표자전화번호.slice(3, 7),
    phoneNumber3: props.member.대표자전화번호.slice(7, 11),
    managerPhone1: props.member.담당자전화번호.slice(0, 3),
    managerPhone2: props.member.담당자전화번호.slice(3, 7),
    managerPhone3: props.member.담당자전화번호.slice(7, 11),
    email1: props.member.담당자이메일.split("@")[0],
    email2: props.member.담당자이메일.split("@")[1],
    companyAddress1: props.member.우편번호,
    companyAddress2: props.member.주소,
    addressDetail: props.member.상세주소,
    companyAddress21: props.member.우편번호2,
    companyAddress22: props.member.주소2,
    addressDetail2: props.member.상세주소2,
    remarks: props.member.비고,
    file: null,
  }
})
const uploadedFileName = ref("");
const businessNumber1Input = ref<HTMLInputElement | null>(null);
const businessNumber2Input = ref<HTMLInputElement | null>(null);
const businessNumber3Input = ref<HTMLInputElement | null>(null);

const handleFileUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files ? target.files[0] : null;
  form.value.file = file;
  uploadedFileName.value = file ? file.name : "";
};

const validateForm = (): boolean => {
  if (!form.value.companyName) {
    alert("사업자명을 입력해주세요.");
    return false;
  }
  if (!form.value.businessNumber1 || !form.value.businessNumber2 || !form.value.businessNumber3) {
    alert("사업자번호를 모두 입력해주세요.");
    return false;
  }
  if (!form.value.managerName) {
    alert("대표자명을 입력해주세요.");
    return false;
  }
  if (!form.value.phoneNumber1 || !form.value.phoneNumber2 || !form.value.phoneNumber3) {
    alert("대표자 전화번호를 모두 입력해주세요.");
    return false;
  }
  if (!form.value.email1 || !form.value.email2) {
    alert("담당자 이메일을 입력해주세요.");
    return false;
  }
  if (!form.value.companyAddress1 || !form.value.companyAddress2) {
    alert("우편번호와 주소를 입력해주세요.");
    return false;
  }
  return true;
};

const signUp = async () => {
  if (!validateForm()) return;

  emit("setUser", form.value);
};

const searchAddr = (seq: number) => {
  const daum = (window as any).daum;
  new daum.Postcode({
    oncomplete(data: any) {
      if(seq === 1) {
        form.value.companyAddress1 = data.zonecode;
        form.value.companyAddress2 = data.address;
      } else {
        form.value.companyAddress21 = data.zonecode;
        form.value.companyAddress22 = data.address;
      }
    },
  }).open();
};

// 숫자만 입력 가능하도록 처리하는 함수
const handleBusinessNumber = (currentField: 'businessNumber1' | 'businessNumber2' | 'businessNumber3', nextField: '' | 'businessNumber2' | 'businessNumber3', maxLength: number) => {
  // 현재 입력된 값
  let value = form.value[currentField] as string;
  
  // 숫자만 추출
  const numericValue = value.replace(/[^0-9]/g, '');
  
  // v-model 업데이트
  form.value[currentField] = numericValue;
  
  // 최대 길이에 도달하고 다음 필드가 있으면 다음 필드로 포커스 이동
  if (numericValue.length >= maxLength && nextField) {
    const nextInput = {
      'businessNumber2': businessNumber2Input,
      'businessNumber3': businessNumber3Input
    }[nextField];
    
    if (nextInput && nextInput.value) {
      nextInput.value.focus();
    }
  }
};
const formatBusinessNumber = () => {
  const num1 = form.value.businessNumber1.padStart(3, '0');
  const num2 = form.value.businessNumber2.padStart(2, '0');
  const num3 = form.value.businessNumber3.padStart(5, '0');
  
  return `${num1}-${num2}-${num3}`;
};
</script>

<style scoped>
.page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
}

.page_header {
  padding: 30px 30px 15px 30px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 24px;
  /* text-align: center; */
}

.page_contents {
  display: flex;
  width: 100%;
  flex-direction: column;
  /* gap: 30px; */
  align-items: center;
  width: 800px;
}

.form-group {
  width: 775px;
  display: flex;
  align-items: center;
  height: 71px;
  border-bottom: 0.5px solid #d0d0d0;
}

label {
  width: 150px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  margin-right: 20px;
  text-align: left;
}

input::-webkit-inner-spin-button {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}

input[type="text"],
input[type="number"],
input[type="search"],
button {
  width: 249px;
  height: 39px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #d0d0d0;
  background-color: #f6f7fb;
}

.company-input input {
  width: 249px;
  height: 39px;
}

.business-inputs {
  display: flex;
}

.business-inputs input {
  width: 113px;
  height: 39px;
  margin-right: 8px;
  display: flex;
}

.phone-inputs {
  display: flex;
}

.phone-inputs input {
  width: 113px;
  height: 39px;
  margin-right: 8px;
  display: flex;
}

.email-inputs {
  display: flex;
  align-items: center;
}

.email-inputs .email1 {
  width: 113px;
  height: 39px;
}

.email-inputs .email2 {
  width: 198px;
  height: 39px;
}

.email-inputs span {
  margin: 0 5px;
}

.dot {
  margin-left: 15px;
  margin-right: 15px;
}

.address-inputs {
  display: flex;
  align-items: center;
}

.address-inputs .address1 {
  width: 113px;
  height: 39px;
  margin-right: 8px;
  background-image: url("@/assets/images/icon-search.png");
  background-repeat: no-repeat;
  background-position: right 5px center;
  background-size: 16px 16px;
  cursor: pointer;
}

.address-inputs .address2 {
  width: 234px;
  height: 39px;
}

.filebox {
  display: inline-block;
  height: 40px;

  vertical-align: middle;
  border-radius: 4px;
  width: 78%;
  color: #000;
  display: flex;
  align-items: center;
  gap: 18px;
}
.file-name {
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
}

.filebox label {
  display: inline-block;
  text-align: center;
  width: 113px;
  height: 39px;
  padding: 9px 21px;
  border-radius: 4px;
  color: #000;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  cursor: pointer;
}

.filebox input[type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  overflow: hidden;
}

.submit-button {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 16px;
  width: 189px;
  height: 41px;
  background-color: #3382e9;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
  margin-top: 52px;
  padding: 10px 65px 9px 65px;
  line-height: 22px;
  text-align: center;
}

.submit-btn {
  text-align: center;
}

.auth-button {
  background-color: #383838;
  color: white;
  padding: 9px 23px;
  cursor: pointer;
  width: 101px;
}

.form_label {
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Bold";
}

#input-wrapper {
  border-bottom: 3px solid black;
  border-top: 3px solid black;
}

.join_header {
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Bold";
  padding-bottom: 17px;
  width: 775px;
  display: flex;
}

.join-container {
  width: 100%;
  margin: auto;
}

.join-agree-container {
  margin-bottom: 49px;
}

.checkbox-container {
  display: inline-block;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
}

.checkbox-container input[type="checkbox"] {
  display: inline-block;
  margin-right: 5px;
}

.agree-privacy {
  font-family: "Noto Sans CJK KR-Light";
  padding-left: 8px;
}

.button-container {
  text-align: center;
}

button {
  background-color: #3382e9;
  font-family: "Noto Sans CJK KR-Medium";
  color: white;
  width: 189px;
  height: 41px;
  padding: 10px 20px;
  border: none;
  border-radius: px;
  cursor: pointer;
  display: inline-block;
}

.steps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 696px;
  padding-bottom: 65px;
}

.step {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.step_circle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  width: 12px;
  height: 12px;
  background: #d8d8d8;
  position: relative;
}

.step.active .step_circle {
  border: 3px solid #337ab7;
  width: 18px;
  height: 18px;
  background: white;
}

.step.active .step_circle div {
  color: #337ab7;
}

.step_line {
  height: 2px;
  background: #d8d8d8;
  width: 214px;
}

.active .step_line {
  width: 208px;
  background: #337ab7;
}

.step_labels {
  display: flex;
  flex-direction: row;
  /* width: 765px; */
}

.step_label {
  position: absolute;
  width: 150px;
  text-align: center;
  bottom: -31px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Regular";
  line-height: 19px;
}

.page_header_line {
  width: 36px;
  border-bottom: 2px solid #000000;
  margin-bottom: 47px;
}
</style>
